export default {
  appResourceName: 'creditlines',
  hasuraResourceName: 'creditline_view_full_credit_lines',
  fields: [
    {
      app: 'available',
      hasura: 'available',
    },
    {
      app: 'balance',
      hasura: 'balance',
    },
    {
      app: 'businessProductId',
      hasura: 'businessproductid',
    },
    {
      app: 'importerName',
      hasura: 'buyer',
    },
    {
      app: 'currency',
      hasura: 'currency',
    },
    {
      app: 'customerId',
      hasura: 'customerId',
    },
    {
      app: 'duration',
      hasura: 'duration',
    },
    {
      app: 'expires_at',
      hasura: 'expires_at',
    },
    {
      app: 'gracePeriod',
      hasura: 'gracePeriod',
    },
    {
      app: 'grossRate',
      hasura: 'grossRate',
    },
    {
      app: 'interestRatePerPeriod',
      hasura: 'interestRatePerPeriod',
    },
    {
      app: 'lateFeeMultiplier',
      hasura: 'lateFeeMultiplier',
    },
    {
      app: 'maxDays',
      hasura: 'maxDays',
    },
    {
      app: 'maxValue',
      hasura: 'maxValue',
    },
    {
      app: 'overdraft',
      hasura: 'overdraft',
    },
    {
      app: 'status',
      hasura: 'status',
    },
    {
      app: 'lineSize',
      hasura: 'lineSize',
    },
    {
      app: 'allocated',
      hasura: 'allocated',
    },
    {
      app: 'customer',
      hasura: 'customer',
    },
    {
      app: 'buyerCountry',
      hasura: 'buyerCountry',
    },
    {
      app: 'openedAt',
      hasura: 'opened_at',
    },
  ],
  buildRequest: {},
}
